import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip, Form, Input, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import IconForgotPassword2 from './IconForgotPassword2';
import UserManagementService from '../../../services/UserManagement.service';
import useNotify from '../../../context/Notification/useNotify';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UserService from '../../../services/UserService';

export default function ChangepasswordForm() {
    const date = new Date(new Date().setHours(0, 0, 0, 0));
    const EndDate = UserService.getEndDate()?.split('/');
    const StartDate = UserService.getStartDate()?.split('/');

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const notify = useNotify();

    const strongRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~=!@#$%^&*()_+\-]).{8,}$/;
    const thaiRegex = /^(?=.*[ก-๏])/;

    const [form] = Form.useForm();
    const onFinish = async (values) => {
        try {
            await UserManagementService.changePassword(values);
            navigate('/successfully', { state: { status: 'success' } });
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('errorText.errorCurrentPassword'),
            });
            console.log(error);
        }
    };

    return (
        <>
            <div className="justify-center w-[700px]">
                <div className="absolute top-8 right-10 text-sm z-30">
                    <span
                        className={classNames('cursor-pointer mx-2', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'th',
                        })}
                        onClick={() => i18n.changeLanguage('th')}
                    >
                        TH
                    </span>
                    |
                    <span
                        className={classNames('cursor-pointer  mx-2 ', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'en',
                        })}
                        onClick={() => i18n.changeLanguage('en')}
                    >
                        EN
                    </span>
                </div>
                <div className="text-center mt-16 mb-2 ">
                    <IconForgotPassword2 />
                </div>
                <div className="mb-6">
                    <div className="text-3xl font-[500] px-16">
                        {t('passwordPage.ChangePasswordTitle')}
                    </div>
                    <div className="text-tiny font-[400] px-16">
                        {t('passwordPage.ChangePasswordDesc')}
                    </div>
                </div>
                <Form
                    form={form}
                    className="px-16 space-y-5"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <div className="space-y-2">
                        <Form.Item
                            name="currentPassword"
                            label={
                                <span className="text-sm font-normal">
                                    {t('passwordPage.CurrentPassword')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input.Password
                                className="rounded-lg bg-[#f5f6ff]"
                                size="large"
                                placeholder={t('passwordPage.CurrentPassword')}
                            />
                        </Form.Item>
                    </div>
                    <div className="space-y-2">
                        <div className="flex space-x-2 items-center">
                            <div className="text-sm font-normal">
                                {t('passwordPage.NewPassword')}
                                <span
                                    className="ml-1 text-[#ff4d4f] text-sm lead-[1px]"
                                    style={{ fontFamily: 'SimSun, sans-serif' }}
                                >
                                    *
                                </span>
                            </div>
                            <Tooltip
                                placement="right"
                                overlayClassName="min-w-[23%]"
                                title={
                                    <>
                                        <div>{t('passwordPage.ruleTitle')}</div>
                                        <div>- {t('passwordPage.rule1')}</div>
                                        <div>- {t('passwordPage.rule2')} </div>
                                        <div>- {t('passwordPage.rule3')}</div>
                                        <div>- {t('passwordPage.rule4')} </div>
                                    </>
                                }
                            >
                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                    <ExclamationCircleOutlined />
                                </a>
                            </Tooltip>
                        </div>
                        <Form.Item
                            name="newPassword"
                            hasFeedback
                            rules={[
                                ({ getFieldValue }) => ({
                                    required: true,
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject(
                                                new Error(
                                                    t('errorText.requiredField')
                                                )
                                            );
                                        } else if (thaiRegex.test(value)) {
                                            return Promise.reject(
                                                t('errorText.validatePassword')
                                            );
                                        } else if (
                                            strongRegex.test(value) &&
                                            value.length >= 8
                                        ) {
                                            return Promise.resolve();
                                        } else if (
                                            getFieldValue('currentPassword') ===
                                            value
                                        ) {
                                            return Promise.reject(
                                                new Error(
                                                    t(
                                                        'errorText.validateCurentPasswordEquelNewpassword'
                                                    )
                                                )
                                            );
                                        }
                                        return Promise.reject(
                                            new Error(
                                                t('errorText.validatePassword')
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                className="rounded-lg bg-[#f5f6ff]"
                                size="large"
                                placeholder={t('passwordPage.NewPassword')}
                            />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item
                            hasFeedback
                            name="confirmPassword"
                            label={
                                <span className="text-sm font-normal">
                                    {t('passwordPage.ConfirmNewPassword')}
                                </span>
                            }
                            dependencies={['newPassword']}
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'passwordPage.ConfirmPasswordIsRequired'
                                    ),
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue('newPassword') ===
                                                value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                t('errorText.validateConfirm')
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                className="rounded-lg bg-[#f5f6ff]"
                                size="large"
                                placeholder={t(
                                    'passwordPage.ConfirmNewPassword'
                                )}
                            />
                        </Form.Item>
                    </div>
                    <div className="space-y-2">
                        <Form.Item>
                            <div className="flex space-x-4">
                                <div>
                                    <Button
                                        className="w-[150px] text-[#7B67FB] border-[#7B67FB]"
                                        size="large"
                                        onClick={() => {
                                            let expiredDate = new Date(
                                                +EndDate[2],
                                                EndDate[1] - 1,
                                                +EndDate[0]
                                            );
                                            let effectiveDate = new Date(
                                                +StartDate[2],
                                                StartDate[1] - 1,
                                                +StartDate[0]
                                            );
                                            if (date < effectiveDate) {
                                                navigate(
                                                    '/package-not-available'
                                                );
                                            } else if (date >= expiredDate) {
                                                navigate('/package-expired');
                                            } else {
                                                navigate('/');
                                            }
                                        }}
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        className="w-[150px]"
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        {t('common.Confirm')}
                                    </Button>
                                </div>
                            </div>
                        </Form.Item>
                    </div>
                </Form>
            </div>
        </>
    );
}
